import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Config from "config";
import { useSelector, useDispatch } from "react-redux";
// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
const backUrl = Config.backOffice.url;
const api = Config.backOffice.apiName;

const SidebarContent = (props) => {
  // const menu = useSelector((state) => state.Login.menu);
  const menu = JSON.parse(localStorage.getItem("sideBar_" + api));

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent && parent.childNodes[0]) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }

      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (
        pathName === items[i].pathname ||
        pathName.startsWith(items[i].pathname + "/") ||
        (pathName.startsWith(`/${backUrl}/fx_paiements/`) &&
          items[i].pathname === `/${backUrl}/fx_paiements/dash`)
      ) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }
  const [icon, setIcon] = useState(localStorage.getItem("leftSideBar"));

  useEffect(() => {
    const checkLocalStorageChange = () => {
      const currentIcon = localStorage.getItem("leftSideBar");
      if (currentIcon !== icon) {
        setIcon(currentIcon);
      }
    };

    const intervalId = setInterval(checkLocalStorageChange, 500);

    window.addEventListener("storage", checkLocalStorageChange);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("storage", checkLocalStorageChange);
    };
  }, [icon]);
  return (
    <React.Fragment>
      <style>
        {`
          .sidebar-footer {
            position: relative;
            bottom: 0;
            width: 100%;
            text-align: center; /* Center-align the text and icon */
          }

          .sidebar-footer li {
            list-style-type: none;
          }

          .sidebar-footer a {
            display: flex;
            align-items: center;
            padding: 10px 15px;
            color: #ffffff;
            text-decoration: none;
            background-color: #555B21;
          }

          .sidebar-footer a:hover span {
            color: #000000; /* Change the text color on hover */
          }

          .sidebar-footer a i {
            margin-right: 10px;
            color: #ffffff;
          }
        `}
      </style>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            {menu.map((menu, index) => (
              <li key={index}>
                {menu.children && menu.children.length > 0 ? (
                  <Link to={"/null"} className="has-arrow">
                    {props.t(menu.father.name) === "PME" ? (
                      <i className="bx bx-package"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Config" ? (
                      <i className="bx bx-cog"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Fusion documentaire" ? (
                      <i className="bx bx-file"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Partenaires" ? (
                      <i className="mdi mdi-handshake"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Souscriptions" ? (
                      <i className="mdi mdi-wallet-plus-outline"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Administration" ? (
                      <i className="bx bx-user-plus"></i>
                    ) : (
                      ""
                    )}

                    <span>{props.t(menu.father.name)}</span>
                  </Link>
                ) : props.t(menu.father.name) == "Déconnexion" ? null : (
                  <Link
                    to={`${backUrl}/${menu.father.route}`}
                    className={
                      path.pathname == `${backUrl}/${menu.father.route}` ||
                      path.pathname.includes(`${backUrl}/${menu.father.route}/`)
                        ? "mm-active"
                        : ""
                    }
                  >
                    {props.t(menu.father.name) == "Tableau de bord" ? (
                      <i className="bx bx-home-circle"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Investisseurs" ? (
                      <i className="mdi mdi-account-multiple-outline"></i>
                    ) : (
                      ""
                    )}{" "}
                    {props.t(menu.father.name) == "Mes documents personnels" ? (
                      <i className="bx bxs-file-doc"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Mes documents" ? (
                      <i className="bx bx-file-blank"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Impressions" ? (
                      <i className="bx bx-printer"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Mes participations" ? (
                      <i className="mdi mdi-wallet-plus-outline"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Mes CGP" ? (
                      <i className="bx bx-wallet"></i>
                    ) : (
                      ""
                    )}
                    {props.t(menu.father.name) == "Mes informations" ? (
                      <i className="bx bx-user-circle"></i>
                    ) : (
                      ""
                    )}
                    {/* {props.t(menu.father.name) == "Déconnexion" ? (
                      <i className="bx bx-log-out"></i>
                    ) : (
                      ""
                    )} */}
                    <span>{props.t(menu.father.name)}</span>
                  </Link>
                )}
                {menu.children && menu.children.length > 0 && (
                  <ul className="sub-menu">
                    {menu.children.map((child, childIndex) => (
                      <li key={childIndex}>
                        <Link
                          to={`${backUrl}/${child.route}`}
                          className={
                            path.pathname === `${backUrl}/${child.route}` ||
                            path.pathname.includes(
                              `${backUrl}/${child.route.substring(
                                0,
                                child.route.indexOf("/") + 1
                              )}/`
                            ) ||
                            (path.pathname === `${backUrl}/fx_paiements/list` &&
                              `${backUrl}/${child.route}` ===
                                `${backUrl}/fx_paiements/dash`)
                              ? "mm-active"
                              : ""
                          }
                          z
                        >
                          {props.t(child.name)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div id="sideBar">
          <ul className="metismenu list-unstyled" id="side-menu">
            <div className="sidebar-footer">
              <li style={{ fontSize: "13px", padding: "10px 5px" }}>
                <Link to={`${backUrl}/logout`}>
                  <i style={{ fontSize: "22px" }} className="bx bx-log-out"></i>
                  {icon == "icon" ? null : <span>{props.t("Logout")}</span>}
                </Link>
              </li>
            </div>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
